import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { pageTransition } from '@/lib/motion';

interface PageTransitionProps {
  children: React.ReactNode;
  /**
   * Klassen fuer den Bewegungs-Container.
   *
   * Er sass bis hierher ohne jede Klasse zwischen dem hoehenbegrenzten
   * `<main>`-Kind und der Seite: ein Block, der mit seinem Inhalt waechst.
   * Eine Seite mit `h-full` loeste ihre 100 % damit gegen einen Container mit
   * `height: auto` auf und wuchs ueber den sichtbaren Bereich hinaus.
   *
   * Auf der Werkbank hiess das konkret: die Karte wurde 761 px hoch in einem
   * 615 px hohen Bereich, und die Entscheidungsleiste an ihrem Fuss lag unter
   * dem Falz. Solange die Leiste `position: fixed` war, ist das niemandem
   * aufgefallen - sie klebte am Fensterrand und nicht an der Karte.
   *
   * Wirkt ausschliesslich auf den Fluid-Routen (`FLUID_ROUTES` in
   * `Layout.tsx`, heute nur `/workbench`): nur dort ist `<main>` eine
   * Flex-Spalte. Auf allen uebrigen Seiten ist `<main>` ein Block mit Padding,
   * dort ist `flex-1` wirkungslos und `min-h-0` folgenlos.
   */
  className?: string;
}

export function PageTransition({ children, className }: PageTransitionProps) {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div key={location.pathname} className={className} {...pageTransition}>
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
